import { Boundaries } from "@planzone/core";
import { State } from "./types";

function handleUseProjectModel(
  state: State,
  { zone, project }: Boundaries["useProjectModel"]["success"],
): State {
  return {
    ...state,
    projects: [...state.projects, { ...project, zone }],
  };
}

export { handleUseProjectModel };
